import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { TranslateModule } from '@ngx-translate/core';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { DateRangeService } from './date-range/services/date-range.service';
import { CalendarService } from './date-range/services/calendar.service';
import { CustomDateSelectorComponent } from '../shared/components/custom-date-selector/custom-date-selector.component';
import { CalendarComponent } from './calendar/calendar.component';
import { DateRangeComponent } from './date-range/date-range.component';
import { TimePickerComponent } from './time-picker/time-picker.component';

@NgModule({
  declarations: [
    CustomDateSelectorComponent,
    DateRangeComponent,
    CalendarComponent,
    TimePickerComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NzSelectModule,
    ScrollingModule,
    TranslateModule,
  ],
  providers: [DateRangeService, CalendarService],
  exports: [DateRangeComponent, CalendarComponent, CustomDateSelectorComponent],
})
export class LibraryModule {}
